import React from 'react';
const Error = ({mensaje}) => (
    <p className='text-uppercase text-center error mb-3'>{mensaje}</p>
);
 
export default Error;